<div class="row w-100 pt-4 text-center margin-auto">
  <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Ajouter une adresse de livraison</div>
</div>
<div class="margin-auto mt-3">
  <div class="col-12">
    <form [formGroup]="addressFrom">
      <div class="civility-grid mb-3">
        <strong>Civilité*</strong>
        <div class="input-grid">
          <div>
            <input type="radio" id="civility1" formControlName="civility" name="civility" value="Mr">
            <label class="form-check-label" for="civility1">Monsieur</label>
          </div>
          <div>
            <input type="radio" id="civility2" name="civility" formControlName="civility" value="Mme">
            <label class="form-check-label" for="civility2">Madame</label>
          </div>
        </div>
      </div>

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Nom*</span>
        <input id="lastName" type="text" class="form-control" minlength="1" maxlength="35" placeholder="Nom" formControlName="lastName" autocomplete="family-name" required>
        @if (addressFromSubmitted && addressFrom.controls.lastName.errors) {
          <small class="form-text error-message">{{ getError('lastName') }}</small>
        }
      </div>

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Prénom*</span>
        <input id="firstName" type="text" class="form-control" minlength="1" maxlength="35" placeholder="Prénom*" formControlName="firstName" autocomplete="given-name" required>
        @if (addressFromSubmitted && addressFrom.controls.firstName.errors) {
          <small class="form-text error-message">{{ getError('firstName') }}</small>
        }
      </div>

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Société</span>
        <input id="company"  type="text" class="form-control" maxlength="35" placeholder="Société" formControlName="company" autocomplete="organization">
        @if (addressFromSubmitted && addressFrom.controls.company.errors) {
          <small class="form-text error-message">{{ getError('company') }}</small>
        }
      </div>

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Intitulé de l'adresse*</span>
        <input id="label" type="text" class="form-control" minlength="1" maxlength="45" placeholder="Domicile" formControlName="label" required>
        @if (addressFromSubmitted && addressFrom.controls.label.errors) {
          <small class="form-text error-message">{{ getError('label') }}</small>
        }
      </div>

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Rue*</span>
        <input id="street" type="text" class="form-control" minlength="1" maxlength="45" placeholder="Rue" formControlName="street" autocomplete="street-address" required>
        @if (addressFromSubmitted && addressFrom.controls.street.errors) {
          <small class="form-text error-message">{{ getError('street') }}</small>
        }
      </div>

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Complément d'adresse</span>
        <input id="addressComplement" type="text" class="form-control" maxlength="45" placeholder="Complément d'adresse" formControlName="addressComplement">
        @if (addressFromSubmitted && addressFrom.controls.addressComplement.errors) {
          <small class="form-text error-message">{{ getError('addressComplement') }}</small>
        }
      </div>

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Code postal*</span>
        <input id="zipCode"  type="text" class="form-control" minlength="1" maxlength="5" placeholder="Code postal" formControlName="zipCode" autocomplete="postal-code" required>
        @if (addressFromSubmitted && addressFrom.controls.zipCode.errors) {
          <small class="form-text error-message">{{ getError('zipCode') }}</small>
        }
      </div>

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Ville*</span>
        <input id="city" type="text" class="form-control" minlength="1" maxlength="45" placeholder="Ville" formControlName="city" autocomplete="locality" required>
        @if (addressFromSubmitted && addressFrom.controls.city.errors) {
          <small class="form-text error-message">{{ getError('city') }}</small>
        }
      </div>

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Lieu dit</span>
        <input id="placeName" type="text" class="form-control" minlength="1" maxlength="45" placeholder="Lieu dit" formControlName="placeName">
        @if (addressFromSubmitted && addressFrom.controls.placeName.errors) {
          <small class="form-text error-message">{{ getError('placeName') }}</small>
        }
      </div>
      <div class="cta_container text-center">
        <button type="button" class="cta_cancel column" (click)="goToAddressPage()">Annuler<span></span></button>
        <button id="submit-button" type="button" class="cta_btn level_2 column" (click)="save()">Enregistrer<span></span></button>
      </div>
    </form>
  </div>
</div>


@if (null !== display) {
  <div #loaderWrapper id="loader-wrapper" [ngStyle]="{'display':display}">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <h1 class="w-100 bold-text text-center prixtel-color margin-auto">Attention !</h1>
        <div class="modal-body">
          Votre adresse de livraison :<br/>
          <span class="bold-label-text">{{ addressFrom.get('street').value }}, </span>
          @if (addressFrom.get('addressComplement').value != '' && addressFrom.get('addressComplement').value != null) {
            <span class="bold-label-text">{{ addressFrom.get('addressComplement').value }}, </span>
          }
          <span class="bold-label-text">{{ addressFrom.get('zipCode').value }} {{ addressFrom.get('city').value }}, France</span>
          <span class="bold-label-text prixtel-color pl-1">n'a pas été reconnue.</span>
          <br/>
          <span class="bold-label-text prixtel-color pl-1">Vous risquez de ne pas recevoir votre carte sim.</span>
          <br/>
          Vous pouvez modifier votre adresse ou la valider en cliquant sur Continuer.
        </div>
        <div class="modal-footer">
          <a class="bold-label-text" (click)="closeModal()">Modifier votre adresse</a>
          <button type="button" class="cta_btn level_2" (click)="byPassGoogleCheckAddressApi()">Continuer<span></span></button>
        </div>
      </div>
    </div>
  </div>
}
